import { useSelector } from 'react-redux';

import { NonEmptyArray } from '../../../packages/JsonQuery';
import { checkIsHotelsSearch } from '../../../packages/JsonQuery/utils/checkIsHotelsSearch';
import { selectIsPriceExperimentActive } from '../../common/selectors/experiments/selectPriceExperiment';
import { selectResultsJsonQuery } from '../../common/selectors/results';
import { useHotelsEnabled } from '../../common/utils/experiments';
import { useStarRatingEnabled } from '../../common/utils/experiments/hotels/starRating';
import { EMobileFilters } from '../types/filters';

export function useFiltersList(): NonEmptyArray<EMobileFilters> {
  const jsonQuery = useSelector(selectResultsJsonQuery);
  const isHotelSearch = checkIsHotelsSearch(jsonQuery);
  const isHotelsEnabled = useHotelsEnabled();
  const isStarRatingEnabled = useStarRatingEnabled();
  const isPriceExperimentActive = useSelector(selectIsPriceExperimentActive);

  if (isHotelSearch && isHotelsEnabled) {
    return [
      EMobileFilters.region,
      EMobileFilters.dates,
      EMobileFilters.guests,
      EMobileFilters.price,
      isStarRatingEnabled && EMobileFilters.starRating,
      EMobileFilters.offerType,
    ].filter(Boolean) as NonEmptyArray<EMobileFilters>;
  }

  return [
    EMobileFilters.moreFilters,
    EMobileFilters.region,
    EMobileFilters.dates,
    isPriceExperimentActive && EMobileFilters.price,
    EMobileFilters.guests,
    EMobileFilters.offerType,
  ].filter(Boolean) as NonEmptyArray<EMobileFilters>;
}
